import { defineComponent as _defineComponent } from 'vue'
import moment, { Moment } from 'moment';
import downloadCsv from 'vue-json-csv';
import DateRangePickerComponent from '@/components/common/DateRangePickerComponent/DateRangePickerComponent.vue';
import TrackingRecordsMap from '@/components/common/TrackingRecordsMap/TrackingRecordsMap.vue';
import './styles/map-viewer-component.scss';
import { PropType } from 'vue/types/v3-component-props';
import { computed } from 'vue';
import { MapViewerEmpty,
  MapViewerEmptyResult,
  MapViewerError,
  MapViewerLoading } from './components/MapViewerState/MapViewerState.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapViewerComponent',
  props: {
  title: {
    type: String,
    default: ''
  },
  single: {
    type: Boolean,
    default: false
  },
  deviceIdLabel: {
    type: String,
    default: ''
  },
  device: {
    type: Object,
    default: () => ({})
  },
  defaultDateRangeValue: {
    type: Array as PropType<Moment[]>,
    default: [] as Moment[]
  },
  mapState: {
    type: String as PropType<'error' | 'loading' | 'fetched' | 'empty' | 'noResult'>,
    default: ''
  },
  deviceRawDataJourney: {
    type: Array as PropType<number[][]>,
    default: () => ([])
  },
  layers: {
    type: Array as PropType<Array<'raw' | 'mapMatched' | 'default'>>,
    default: () => ([])
  },
  vtrObject: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['handleDateRange', 'query-device-history'],
  setup(__props, { emit }) {

const props = __props;




function handleDateRange(payload: Moment[]) {
  emit('handleDateRange', payload);
}

function refreshData() {
  handleDateRange(props.defaultDateRangeValue);
  emit('query-device-history');
}

const formatHeading = (value: any) => {
  const rounded = Number(value).toFixed(1);
  const tenth = Math.round(parseFloat(rounded) * 10);
  return tenth.toString().padStart(4, '0');
};

const formatHdop = (value: any) => {
  const rounded = Number(value).toFixed(1);
  const intVal = Math.round(parseFloat(rounded) * 10);
  return intVal.toString().padStart(3, '0');
};

const vtrObjectForCsv = computed(() => (props.vtrObject
      && props.vtrObject.features
  ? props.vtrObject.features.map((feature: any) => ({
    'datetime (UTC)': moment.unix(feature.properties.timestamp).utc().format('DD/MM/YYYY HH:mm:ss'),
    'latitude (°)': feature.geometry.coordinates[1],
    'longitude (°)': feature.geometry.coordinates[0],
    'cellID': feature.properties.cellID,
    'elevation (m)': feature.properties.elevation,
    'HDOP': feature.properties.hdop,
    'heading (°)': feature.properties.heading,
    'speed (km/h)': feature.properties.speed,
    'obe status': feature.properties.obeStatus,
    'exemption': feature.properties.exemption,
    'private mode': feature.properties.privateMode,
    'tolling state': feature.properties.tollingState,
    'Position Counter': feature.properties.counter
  })) : []));

const vtrObjectForCsvBalm = computed(() => (
  props.vtrObject?.features?.map((feature: any) => ([
    moment.unix(feature.properties.timestamp).utc().format('YYYYMMDDHHmmss[Z]'),
    Math.trunc(feature.geometry.coordinates[1] * 1e6),
    Math.trunc(feature.geometry.coordinates[0] * 1e6),
    formatHeading(feature.properties.heading),
    Math.round((feature.properties.speed * 100000) / 3600).toString().padStart(4, '0'),
    feature.properties.usedSatellites?.toString().padStart(2, '0'),
    formatHdop(feature.properties.hdop),
    0,
    0
  ])) ?? []
));

const csvFileName = computed(() => (props.device.shortDeviceId && props.defaultDateRangeValue.length === 2
  ? `${props.device.shortDeviceId}-${moment(props.defaultDateRangeValue[0]).utc()}-${moment(props.defaultDateRangeValue[1]).utc()}.csv`
  : 'corrupted-file'));


return { __sfc: true,props, emit, handleDateRange, refreshData, formatHeading, formatHdop, vtrObjectForCsv, vtrObjectForCsvBalm, csvFileName, downloadCsv, DateRangePickerComponent, TrackingRecordsMap, MapViewerEmpty, MapViewerEmptyResult, MapViewerError, MapViewerLoading }
}

})